<template>
  <div class="partner-selection-list aligncontent grayed">
    <div v-for="item in items" :key="item.id + ' ' + item.name" class="snappy col-l-4 col-m-6 col-s-12">
      <VItem :item="item" @toggle="$emit('toggle', $event)" @open:exceptions="$emit('open:exceptions', $event)" />
    </div>
    <template v-if="items.length === 0">
      <slot />
    </template>
  </div>
</template>

<script>
import VItem from '@/components/Barring/PartnerSelection/List/Item';

export default {
  name: 'PartnerSelectionList',

  components: { VItem },

  props: {
    items: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style scoped>
.partner-selection-list {
  width: 100%;
  max-height: 564px;
  overflow-x: hidden;
  overflow-y: scroll;
  border: 1px solid #f5f5f5;
  scroll-snap-type: y mandatory;
  scroll-padding: 12px 0 0;
}
.snappy {
  scroll-snap-align: start;
}
</style>
